import axios from "axios";

export function getCompetitions(s: string = '', passed_competitions: boolean = false) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/competition';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (passed_competitions) {
        params.push('passed=1');
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getCompetitionOptions(s: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/competition/options';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getCompetitionSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/competition/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createCompetition(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/competition';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCompetition(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/competition';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteCompetition(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/competition/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}